import { h, Fragment } from "preact";
import { useState, useEffect } from "preact/hooks";
import { positions } from "./constants";

export default function MonogramStepPosition({
  product,
  config,
  setConfig,
  setVisible,
}) {
  if (product.monogramSettings.sidePosition === null) {
    setVisible(false);
    return null;
  }

  setVisible(true);

  const handleChange = (e) => {
    setConfig({ ...config, position: e.target.value, size: null });
  };

  if (!config.position) {
    setConfig({ ...config, position: positions.top });
  }

  return (
    <div className="monogram-config__positions">
      {Object.entries(positions).map(([_, label]) => (
        <label className="monogram-config__position-label monogram-config__radio-label">
          <input
            className="monogram-config__position-input monogram-config__radio-input"
            type="radio"
            name="monogram-position"
            checked={config.position === label}
            onChange={handleChange}
            value={label}
          />
          <div class="monogram-config__position-value">{label}</div>
        </label>
      ))}
    </div>
  );
}
